import useExportReportBase from '../util/exportReportBase';
import { useTranslation } from '../components/LocalizationProvider';

/**
 * Hook de exportação CRUD unificado, com suporte a localização.
 * Os textos são traduzidos através do `t()` do Traccar Web.
 */
const useCrudExports = ({
  titleKey = 'reportDefaultTitle',
  headerKey,
  rows = [],
  columns = [],
  mapper,
  theme,
  t: providedT,
  options = {},
}) => {
  const translate = providedT || useTranslation();
  const mappedRows = mapper
    ? rows.map((r) => mapper(r))
    : Array.isArray(rows)
    ? rows
    : [];

  const reportTitle = translate(titleKey);
  const headerTitle = headerKey ? translate(headerKey) : reportTitle;

  const translatedColumns = (columns || []).map((col) => ({
    ...col,
    headerName: col.headerNameKey ? translate(col.headerNameKey) : col.headerName || col.field,
  }));

  const {
    handleExport,
    handleExportCsv,
    handleExportXlsx,
    handleExportPdf,
  } = useExportReportBase({
    title: reportTitle,
    columns: translatedColumns,
    rows: mappedRows,
    theme,
    t: translate,
    options: {
      ...options,
      titleKey,
      headerTitle,
    },
  });

  return {
    handleExportCsv: () => handleExport('csv'),
    handleExportXlsx: () => handleExport('excel'),
    handleExportPdf: () => handleExport('pdf'),
    handleExport,
  };
};

export default useCrudExports;
